import { __assign, __makeTemplateObject } from "tslib";
import last from 'lodash/last';
import * as React from 'react';
import { withProps } from 'recompose';
import styled from 'styled-components';
import { textAlign } from 'styled-system';
import asRendition from '../../asRendition';
import { px } from '../../utils';
import { Box } from '../Box';
var ContainerBase = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), textAlign);
var BaseContainer = function (props) {
    var gutter = props.theme.space[3];
    var upperLimit = last(props.theme.breakpoints);
    var maxWidth = px(upperLimit - gutter);
    return React.createElement(ContainerBase, __assign({}, props, { maxWidth: maxWidth }));
};
BaseContainer.displayName = 'Container';
BaseContainer.defaultProps = {};
var setDefaultProps = withProps(function (props) {
    return Object.assign({
        px: 3,
        ml: 'auto',
        mr: 'auto',
    }, props);
});
export var Container = asRendition(BaseContainer, [setDefaultProps]);
var templateObject_1;
